import React from "react";
import FolderIcon from "@material-ui/icons/Folder";
import GitHubIcon from "@material-ui/icons/GitHub";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

function SmallProject({title, description, tech, projectlink}) {
  return (
    <div className="col-md-12 card">
      <div className="row card__icons">
        <FolderIcon className="FolderIcon" />
        <span>
          <a><GitHubIcon className="card__icon" /></a>
          <a target="_blank" href={projectlink}><OpenInNewIcon className="card__icon"/></a>         
        </span>
      </div>
      <h5>{title}</h5>
      <p className="otherProjects__descritpion">
        {description}
      </p>
      <p className="otherProjects__tech">{tech}</p>
    </div>
  );
}

export default SmallProject;
